module.exports = __webpack_public_path__ + "static/media/hourglass.40f4fcfd.svg";